window.cities = {
	selector: $('.listCities'),

	init: function () {
		cities.selector.find('.alert-danger').slideUp();
	},

	getList: function () {
		cities.init();

		$.get('/location/cities', [], function (data) {
			cities.selector.find('.loading-cities').slideUp();
			if(!data.error) {
				$cities = cities.selector.find('.cities');
				$cities.html(data.cities);
				$cities.find('.s_city a').each(function (i, e) {
					$(e).attr('href', $(e).attr('href') + '?to='+location.pathname);
				})
			} else {
				cities.selector.find('.alert-danger').html(data.message).slideDown();
			}
		});
	},

	findCity: function (val) {
		val = $.trim(val);
		val = Transliterate(val, true);
		val  = val.toLowerCase();

		var $citiesContent = $("#cities-content");

		if (!val) {
			$citiesContent.find('.section-letter', '.section-letter a').show();
		}

		$citiesContent.find('.section-letter').each(function (i, sectionLetter) {
			$(sectionLetter).show();
			$cities = $(sectionLetter).find('.s_city');
			$cities.hide();
			$cities  = $cities.filter(function(i, cityContainer) {
				var cityTitle = $(cityContainer).find('a').text().toLowerCase();
				var valueUp = cityTitle.charAt(0).toUpperCase();
				var valueSlice = cityTitle.slice(1);
				var value = valueUp + valueSlice;

				if (cityTitle.indexOf(val) !== -1) {
					return true;
				}

				return false;
			});

			$cities.show();

			if (!$cities.length) {
				$(sectionLetter).hide();
			}
		});
	}
};